/**
 * @generated SignedSource<<2a7e18bdac02f3e30a20351fba4e6957>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleActionWidgetArticle$data = {
  readonly entityId: string;
  readonly urlAlias: string;
  readonly " $fragmentSpreads": FragmentRefs<"articleCommentsTriggerArticle">;
  readonly " $fragmentType": "articleActionWidgetArticle";
};
export type articleActionWidgetArticle$key = {
  readonly " $data"?: articleActionWidgetArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleActionWidgetArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "articleActionWidgetArticle",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleCommentsTriggerArticle"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "urlAlias",
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "ec012717b0d1196dee4dcf79e80bac12";

export default node;
